module.exports = __webpack_public_path__ + "img/funfacts2.71207635.png";